<ptl-v3-filter-shell [title]="'translations.filter.completion.name' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <ptl-select
    shell-controls
    class="v3-completion-filter__completion-type-select"
    [options]="completionTypeOptions"
    [(ngModel)]="completionType"
  ></ptl-select>
  <div class="v3-completion-filter__body">
    <ptl-select
      class="v3-completion-filter__filter-type-select"
      [options]="filterTypeOptions"
      [disabled]="!shouldDisplayActivitiesFilters"
      [(ngModel)]="filterType"
    ></ptl-select>
    @if (filterType === 'AT_LEAST' || filterType === 'AT_MOST') {
      <div class="v3-completion-filter__count-row">
        <input
          class="v3-completion-filter__count-input"
          [class.error]="resourceCountError"
          type="number"
          min="0"
          [max]="maxResourceCount"
          autocomplete="off"
          [attr.aria-label]="'translations.global.ariaLabels.specifyQuantityOfActivities' | transloco"
          (ngModelChange)="onInputChange()"
          [(ngModel)]="resourceCount"
        />
        <span class="v3-completion-filter__count-label">
          {{ 'translations.filter.completion.of' | transloco }} {{ maxResourceCount }}
          @if (isPlaylistPage && !isCardPage) {
            {{ 'translations.filter.completion.cardPlural' | transloco }}
          }
          @if (isCardPage && !isPlaylistPage) {
            {{ 'translations.filter.completion.formPlural' | transloco }}
          }
          @if (isAdminPage) {
            {{ 'translations.filter.completion.playlistPlural' | transloco }}
          }
        </span>
      </div>
    }
    @if (filterType === 'CERTAIN_ACTIVITIES') {
      <div class="v3-completion-filter__activities">
        @if (isAdminPage) {
          <ptl-sg-input
            class="v3-completion-filter__search"
            [withIcon]="true"
            [icon]="LucideSearch"
            [placeholder]="'translations.global.search.label.playlists' | transloco"
            [ngModel]="playlistSearchString"
            (inputChange)="onSearchInputChange($event)"
            (focustEnterAction)="onFocus()"
          ></ptl-sg-input>
        }
        <div class="v3-completion-filter__activities-list" (scroll)="onActivitiesScroll($event)">
          @for (resource of certainResources; track $index) {
            <ptl-sg-checkbox
              class="v3-completion-filter__activity"
              [checked]="isResourceChecked(resource)"
              [ariaLabel]="
                isResourceChecked(resource)
                  ? ('translations.global.ariaLabels.uncheckActivityCompletionFilter' | transloco: { activityName: resource.label })
                  : ('translations.global.ariaLabels.checkActivityCompletionFilter' | transloco: { activityName: resource.label })
              "
              (checkboxChange)="changeActivity(resource)"
            >
              <span class="v3-completion-filter__activity-label" [matTooltip]="resource.label" matTooltipClass="medium-tooltip">
                {{ resource.label }}
              </span>
            </ptl-sg-checkbox>
          }
          @if (loadingSearch) {
            <div class="v3-completion-filter__spinner">
              <span class="v3-completion-filter__spinner-icon"></span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ptl-v3-filter-shell>
